import React from 'react';
import classes from './DeleteButton.scss';

export default (props) => {
  return <div className={classes['delete-button']} {...props}></div>;
};
